import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DrivingSchoolInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import DrivingSchoolName from './DrivingSchoolName'
import ContactName from './ContactName'
import PhoneNumber from './PhoneNumber'
import BackAnchor from '../../../../shared/components/BackAnchor'

const DrivingSchoolInformationView = ({ t, i18n, setIsError }) => {
  let history = useHistory()

  const [drivingSchoolNameValid, setDrivingSchoolNameValid] = useState('')
  const [contactNameValid, setContactNameValid] = useState('')
  const [phoneNumberValid, setPhoneNumberValid] = useState('')

  const [drivingSchoolNameError, setDrivingSchoolNameError] = useState('driving_school_information.name_of_driving_school_error')
  const [contactNameError, setContactNameError] = useState('driving_school_information.contact_name_error')
  const [phoneNumberError, setPhoneNumberError] = useState('driving_school_information.daytime_phone_number_error')

  const drivingSchoolName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.drivingSchoolName)
  const contactName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.contactName)
  const phoneNumber = useSelector((state) => state.drivingSchool.drivingSchoolInformation.phoneNumber)

  const backNextProps = {
    prevText: t('driving_school_information.back'),
    prevURL: `/${i18n.language}${t('routes.school_question')}`,
    nextText: t('driving_school_information.next'),
  }

  const onNext = () => {
    try {
      if (validateFields()) {
        history.push(`/${i18n.language}${t('routes.driver_info')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      validateDrivingSchoolName(drivingSchoolName)
      validateContactName(contactName)
      validatePhoneNumber(phoneNumber)
      if (drivingSchoolName === '') {
        setDrivingSchoolNameValid(false)
      }
      if (contactName === '') {
        setContactNameValid(false)
      }
      if (phoneNumber === '') {
        setPhoneNumberValid(false)
      }
      return (
        drivingSchoolNameValid === true &&
        contactNameValid === true &&
        phoneNumberValid === true &&
        drivingSchoolName !== '' &&
        contactName !== '' &&
        phoneNumber !== ''
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateDrivingSchoolName = (name) => {
    try {
      if (name.length > 0) {
        if (name.length > 1) {
          setDrivingSchoolNameValid(true)
        } else {
          setDrivingSchoolNameValid(false)
          setDrivingSchoolNameError('driving_school_information.name_of_driving_school_error_less_characters')
        }
      } else {
        setDrivingSchoolNameValid(false)
        setDrivingSchoolNameError('driving_school_information.name_of_driving_school_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateContactName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          if (name.length > 1) {
            setContactNameValid(true)
          } else {
            setContactNameValid(false)
            setContactNameError('driving_school_information.contact_name_error_less_characters')
          }
        } else {
          setContactNameValid(false)
          setContactNameError('driving_school_information.contact_name_error_invalid')
        }
      } else {
        setContactNameValid(false)
        setContactNameError('driving_school_information.contact_name_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePhoneNumber = (number) => {
    try {
      if (number.length > 0) {
        if (number.length === 12) {
          setPhoneNumberValid(true)
        } else {
          setPhoneNumberValid(false)
          setPhoneNumberError('driving_school_information.phone_number_error_invalid')
        }
      } else {
        setPhoneNumberValid(false)
        setPhoneNumberError('driving_school_information.phone_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <BackAnchor />
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h2>{t('driving_school_information.tell_us_about')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <DrivingSchoolName
            validateDrivingSchoolName={validateDrivingSchoolName}
            drivingSchoolNameError={drivingSchoolNameError}
            drivingSchoolNameValid={drivingSchoolNameValid}
            setIsError={setIsError}
          />
          <ContactName
            validateContactName={validateContactName}
            contactNameError={contactNameError}
            contactNameValid={contactNameValid}
            setIsError={setIsError}
          />
          <PhoneNumber
            validatePhoneNumber={validatePhoneNumber}
            phoneNumberError={phoneNumberError}
            phoneNumberValid={phoneNumberValid}
            setIsError={setIsError}
          />
        </div>
      </div>
      <div className={styles['back_next_margin']}>
        <BackNextButtons props={backNextProps} nextOnClick={onNext} />
      </div>
    </div>
  )
}

export default withTranslation('common')(DrivingSchoolInformationView)
